export const commonConfig = {
  maximumApplicableCards: 3,
  pdpVideosConfig: {
    enabled: true,
    productVideoOptions: {
      autoPlay: true,
      controls: false,
      loop: true,
      muted: true,
    },
    videoPosition: 1,
  },
  staticFeatures: {
    hideSoldOutColorsInStylesSelection: true,
    isPriceFilterSliderEnabled: true,
  },
  validation: {
    address: { length: { max: 50, min: 0 } },
    name: { length: { max: 50, min: 0 } },
    phone: { length: { min: 1 } },
  },
};
